import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IBenchConsultant } from "../../../models/BenchConsultant";
import { format } from "date-fns";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { IModel2 } from "../sales/TableAll";
import { BenchSubmissionForm } from "./BenchSubmissionForm";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";

interface IProps {
    open: boolean,
    toast: any,
    singleData: any,
    req_ID: number,
    hideDialog: () => void,
}

export const BenchConsultantList = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IBenchConsultant[], loading: boolean });
    const [selectedBenchs, setSelectedBenchs] = useState<IBenchConsultant | null>(null);
    const [submission, setSubmission] = useState({ singleData: {}, open: false } as any);
    const dt = useRef<any>(null);
    const getConsultantListByReqCategory = async () => {
        let rowData: any = props.singleData;
        let filter = { job_Title: rowData.req_Job_Title };
        setTableData({ tableData: tableData.tableData, loading: false });
        const response = await Fetch("Consultant_Bench/getBenchConsultantByJobTitle", "GET", null, `filter=${encodeURIComponent(JSON.stringify(filter))}&myReq=1`, props.toast);
        if (response) {
            const data: IBenchConsultant[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };
    const marketing_Status = (rowData: IBenchConsultant) => {
        return (
            <span
                className="cursor-pointer text-cyan-700 underline">
                {rowData.marketing_Status}
            </span>
        );
    };
    const confirmation_Date = (rowData: IBenchConsultant) => {
        let date;
        if (rowData.confirmation_Date) date = format(new Date(rowData.confirmation_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const numOfSub = (rowData: IBenchConsultant) => {
        return (
            <span
                className="cursor-pointer text-cyan-700 underline">
                {rowData.numOfSub}
            </span>
        );
    };
    const numOfECI = (rowData: IBenchConsultant) => {
        return (
            <span
                className="cursor-pointer text-cyan-700 underline">
                {rowData.numOfECI}
            </span>

        );
    };
    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center mr-2">
            <h5 className="m-0">Bench Consultant</h5>
        </div>
    );
    const rightToolbarTemplate = () => {
        return <div className="flex">
            {/* <Button label="Send Email" onClick={() => console.log(selectedBenchs)} className={(selectedBenchs === null || !selectedBenchs.consultant_ID) ? "mr-2 h-2rem w-8rem p-button-sm p-button-outlined" : "mr-2 h-2rem w-8rem"} disabled={(selectedBenchs === null || !selectedBenchs.consultant_ID) ? true : false} /> */}
            <Button label="Quick Submission" onClick={async () => {
                let newData: any = selectedBenchs;
                setSubmission({ singleData: newData, open: true });
            }} className={(selectedBenchs === null || !selectedBenchs?.consultant_ID) ? "h-2rem w-11rem p-button-sm p-button-outlined" : "h-2rem w-11rem"} disabled={(selectedBenchs === null || !selectedBenchs.consultant_ID) ? true : false} />
        </div>
    };
    const hideDialog = () => {
        setSubmission({ singleData: {}, open: false });
        props.hideDialog();
    };
    const ShowCelebration = () => { }

    useEffect(() => {
        if (props.singleData.req_Job_Title) {
            getConsultantListByReqCategory();
        }
    }, [props.singleData]);

    const loginObj: ILogin= JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
                selectionMode={'checkbox'}
                selection={selectedBenchs}
                onSelectionChange={(e) => {
                    const value = e.value as IBenchConsultant;
                    setSelectedBenchs(value);
                }}
            >
                <Column selectionMode="single" />
                <Column field="consultant_ID" header="ID" sortable />
                <Column field="consultant_Name" header="Consultant Name" sortable />
                <Column field="job_Titles" header="Job Title" />
                <Column field="phone" header="Phone No" />
                <Column field="location" header="Location" />
                <Column field="visa_Name" header="Visa" />
                <Column field="rate" header="Rate" />
                <Column field="f2F" header="F2F" />
                <Column field="recruiter" header="Recruiter" />
                <Column field="branch" header="Branch" />
                <Column field="sales" header="Hold By" />
                <Column field="comment" header="Comments" />
                {/* <Column field="numOfSub" header="Sub" body={numOfSub} sortable />
                <Column field="numOfECI" header="ECI" body={numOfECI} sortable /> */}
                <Column field="numOfSub" header="Sub" sortable />
                <Column field="numOfECI" header="ECI" sortable />
                <Column field="priority" header="Priority" sortable />
                {/* <Column field="marketing_Status" header="Status" body={marketing_Status} sortable /> */}
                <Column field="marketing_Status" header="Status" sortable />
                {/* <Column field="benchDate" header="on Bench" /> */}
                 <Column field="benchDate" header="on Bench" body={(RowData: any) => safeFormatDate(RowData.benchDate, 'dd/MM/yyyy', DateFormat)} />
                <Column field="confirmation_Date" header="Cnf Date" body={confirmation_Date} />
                <Column field="consultant_Type" header="Consultant Type" />
                {/* {props.permissions.is_Update && <Column body={actionBodyTemplate} />} */}
            </DataTable>
            {/* <Submission singleData={submission.singleData} open={submission.open} hideDialog={hideSubmissionDialog} toast={props.toast} ShowCelebration={props.ShowCelebration} /> */}
            <BenchSubmissionForm singleData={selectedBenchs} req_ID={props.req_ID} open={submission.open} hideDialog={hideDialog} toast={props.toast} ShowCelebration={ShowCelebration} />
        </>
    );
}